import { create, w, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

import { userstate } from '@holmescorp/lcc-state';

import { ContentContainer } from './index';
import css from '../css/hero.m.css';

export interface HeroProperties {
	additionalClasses?: string[];
	xqa?: string;
}

const factory = create({ userstate, theme }).properties<HeroProperties>();

export const Hero = factory(({ id: widgetId, properties, children, middleware: { theme } }) => {
	const { additionalClasses = [], xqa: incomingXQA = '' } = properties();
	const themeCss = theme.classes(css);

	const id = 'hero';
	const key = `${id}-${widgetId}`;
	const xqa = incomingXQA || `${id}-widget`;

	return w(ContentContainer, { id, key, xqa, additionalClasses: [...additionalClasses, themeCss.container] }, [
		v('div', { classes: [themeCss.root] }, [...children()])
	]);
});

export default Hero;
